module.exports = __webpack_public_path__ + "img/video.066d4293.png";